export default __webpack_public_path__ + "static/media/SWT0840.34I-19864_-17623_0.0f17c80b.jpg";